<template>
  <div class="banner">
    <!-- 游戏banner -->
    <img :src="banner" v-if="banner">
    <!-- 默认banner -->
    <img src="@/assets/banner1.png" v-else>
  </div>
</template>
      
<script>
export default {
  name: "banner",
  props: ["groupInfo"],
  data: function () {
    return {
      banner: "",
    };
  },
  methods: {
    // 获取活动图片
    getImage(id) {
      let data = {
        tm: Date.parse(new Date()),
        papp_id: id,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getImage,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.banner = res.data.data.banner_img;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    // 拿到团队信息后请求banner
    groupInfo: function () {
      this.getImage(this.groupInfo.papp_id);
    },
  },
};
</script>
      
<style scoped>
img {
  width: 100%;
}
</style>